<template>
    <span class="share">
        <el-popover trigger="click" placement="top" width="320" v-model="row.visible">
            <div class="videoList-pr-code-upload padding-20">
                <img :src="row.qrShare" :alt="row.subject">
                <div class="pr-code-text cursor" @click="download(row.qrShare, row.subject)">下载二维码</div>
                <div class="btn-operate">
                    <el-input :disabled="true" :value="row.share || row.shareurlpc" class="condition"></el-input>
                    <el-button  type="primary" size="mini" v-clipboard:copy="row.share || row.shareurlpc" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div>
            </div>
            <el-button slot="reference" type="text" size="small" class="shareBtn">分享</el-button>
        </el-popover>
        <span v-if="!line" class="separator"> | </span>
    </span>
</template>
<script>
import {promiseUrlToQRCode, downloadImage} from 'common/js/tools'
export default {
    name: 'share',
    props: ['row', 'line'],
    data() {
        return {}
    },
    methods: {
        download(imgsrc, name) { // 下载图片地址和图片名
            downloadImage(imgsrc, name)
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError(e) {
            alert('失败')
        }
    }
}
</script>
<style lang="scss">
@import "~common/scss/mixin";
.el-popover{
    .videoList-pr-code-upload{
        text-align: center;
        img{
            width: 160px;
            height: 160px;
        }
        .pr-code-text{
            color: $tcolor-blue;
            padding: 20px 0;
        }
        .btn-operate{
            @include flexBox(space-between);
            .el-input,input{
                width: 210px;
                height: 36px;
                line-height: 36px;
            }
            .el-button{
                min-width: 60px;
            }
        }
    }
}
.shareBtn{
    min-width: 0px !important;
}
</style>